/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconButtonProps as MUIIconButtonProps} from '@material-ui/core/IconButton';
import {MaterialExitCloseIcon} from '../../icons/MaterialExitCloseIcon';
import {dlsShadow} from '../../theme/theme';
import {DLSShadowStyle} from '../../types/types';
import {IconButton} from './IconButton';

export interface CloseButtonProps extends Omit<MUIIconButtonProps, 'children' | 'color'> {
  elementId?: string;
}

/**
 * Close control button rendered via the shared `IconButton`
 * control-button mode with close-specific sizing and shadow props.
 *
 * ```typescript
 * import React from 'react';
 * import {CloseButton} from '@ion/dls/src/components/buttons/CloseButton';
 *
 * const Example = () => (
 *   <CloseButton onClick={onClose} />
 * );
 * ```
 */
export const CloseButton = ({
  ...props
}: CloseButtonProps) => {
  return (
    <IconButton {...props}
      isControlButton
      controlButtonSize={44}
      controlButtonPadding={0}
      controlFrameSize={24}
      controlIconSize={16}
      controlDefaultBorderWidth={0.5}
      controlHoverFilter={dlsShadow(6.3, DLSShadowStyle.DropShadow)}
      controlActiveOuterShadow={dlsShadow(6.4, DLSShadowStyle.Inset)}
      controlActiveFilter={dlsShadow(6.5, DLSShadowStyle.DropShadow)}
      controlActiveInnerShadow={dlsShadow(6.4, 6.5)}
      icon={<MaterialExitCloseIcon />} />
  );
};

export default CloseButton;
